import React, { Component } from "react";
import Toggle from "carbon-components-react/lib/components/ToggleSmall";
import { changeTeacherAvailability } from "../services/apiService";
import { withTranslation } from "react-i18next";
import { trackEvent } from "../services/analyticsService";
import { connect } from "react-redux";
import { saveTeacher } from "../store/actions";

class AvailabilitySwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: this.props.teacher.is_available,
    };
  }
  componentDidMount() {}

  sthToggled(value) {
    trackEvent("Availability Toggle", "Changed");
    changeTeacherAvailability(this.props.teacher.id, value).then((teacher) => {
      this.props.saveTeacher(teacher);
      this.setState({
        toggled: teacher.is_available
      });
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div
        className="navbar-item"
        style={{ display: "flex", alignItems: "center" }}
      >
        {/**<div className="d-none">{t("matchStatus")}: </div>*/}
        <Toggle
          toggled={this.state.toggled}
          //labelA={t("off")}
          //labelB={t("on")}
          aria-label=""
          onToggle={(e) => this.sthToggled(e)}
          className="centered"
          id="toggle-1"
        />
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    teacher: state.teacher
  };
};

const mapDispatchToProps = { saveTeacher };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("kunduz")(AvailabilitySwitch));
